'use client'

import { unescapeHtml } from '@/common/_utils/utils'
import ItdcBbsContent from '@/common/_components/ItdcBbsContent'

const PostList = () => {
  const endpoint = `/pbc/sgqi/oatigs`

  // 각 안내 페이지마다 화면 구성이 다르므로 이곳에서 정의하여
  // 공통 컴포넌트에 Props로 전달
  const renderContent = (post: any) => (
    <div
      className="marB30"
      dangerouslySetInnerHTML={{ __html: unescapeHtml(post?.data?.bbscttCn) }}
    />
  )

  return <ItdcBbsContent endpoint={endpoint} renderContent={renderContent} />
}

export default PostList
